import Achiever from "../../Pages/Achiever/Achiever";
import a from   '../../assets/achievers/achiver1.jpg';


const achievers = [
  {
    name: "Anjali Sharma",
    marks: "96.5%",
    image: "/achievers/anjali.jpg"
  },
  {
    name: "Rohan Verma",
    marks: "94%",
    image: "/achievers/rohan.jpg"
  },
  {
    name: "Meera Singh",
    marks: "98%",
    image: "/achievers/meera.jpg"
  }
];

export default function AchieversSection() {
  return (
    <div className="container py-5 mt-5 text-center">
      <h2 className="text-white mb-4">🌟 Star Achievers of Prakash Institute</h2>
      <div className="d-flex flex-wrap justify-content-center gap-4">
        {achievers.map((achiever, idx) => (
        <Achiever
        name="Anjali Sharma"
        marks="96.5%"
        image={a}
      />
      
        ))}
      </div>
    </div>
  );
}
